import { getEditableNumberCell } from 'utils/tableCells';

import { useMemo } from 'react';
import type { Control } from 'react-hook-form';

import { ConversionCoefficientsKeys, getConversionIndicesCoefficientKey } from '../../Contract/ContractUpdate/utils';

export interface IUseConversionIndicesColumns {
    isEditable?: boolean;
    control?: Control;
}

export const useConversionIndicesColumns = (props: IUseConversionIndicesColumns) => {
    const { isEditable, control } = props;

    return useMemo(
        () => [
            {
                title: 'Вид строительства',
                accessor: 'constructionType',
                renderCell: (row) => row.constructionType.name,
                width: isEditable ? 171 : 231,
            },
            getEditableNumberCell({
                title: 'Кзп',
                accessor: 'kozp',
                nameGetter: (row: any) =>
                    getConversionIndicesCoefficientKey(ConversionCoefficientsKeys.kozp, row.constructionType.id),
                isEditable,
                control,
                doNotCheckRowFlag: true,
                width: isEditable ? 85 : 60,
                textFieldWidth: 'full',
                placeholder: '0',
            }),
            getEditableNumberCell({
                title: 'Кэмм',
                accessor: 'kemm',
                nameGetter: (row: any) =>
                    getConversionIndicesCoefficientKey(ConversionCoefficientsKeys.kemm, row.constructionType.id),
                isEditable,
                control,
                doNotCheckRowFlag: true,
                width: isEditable ? 85 : 60,
                textFieldWidth: 'full',
                placeholder: '0',
            }),
            getEditableNumberCell({
                title: 'Кмтр',
                accessor: 'kmtr',
                nameGetter: (row: any) =>
                    getConversionIndicesCoefficientKey(ConversionCoefficientsKeys.kmtr, row.constructionType.id),
                isEditable,
                control,
                doNotCheckRowFlag: true,
                width: isEditable ? 85 : 60,
                textFieldWidth: 'full',
                placeholder: '0',
            }),
            getEditableNumberCell({
                title: 'Коборуд.',
                accessor: 'keqp',
                nameGetter: (row: any) =>
                    getConversionIndicesCoefficientKey(ConversionCoefficientsKeys.keqp, row.constructionType.id),
                isEditable,
                control,
                doNotCheckRowFlag: true,
                width: isEditable ? 85 : 80,
                textFieldWidth: 'full',
                placeholder: '0',
            }),
            getEditableNumberCell({
                title: 'Кнр',
                accessor: 'knr',
                nameGetter: (row: any) =>
                    getConversionIndicesCoefficientKey(ConversionCoefficientsKeys.knr, row.constructionType.id),
                isEditable,
                control,
                doNotCheckRowFlag: true,
                width: isEditable ? 85 : 60,
                textFieldWidth: 'full',
                placeholder: '0',
            }),
            getEditableNumberCell({
                title: 'Ксп',
                accessor: 'ksp',
                nameGetter: (row: any) =>
                    getConversionIndicesCoefficientKey(ConversionCoefficientsKeys.ksp, row.constructionType.id),
                isEditable,
                control,
                doNotCheckRowFlag: true,
                width: isEditable ? 85 : 60,
                textFieldWidth: 'full',
                placeholder: '0',
            }),
            getEditableNumberCell({
                title: 'Кпир',
                accessor: 'kpir',
                nameGetter: (row: any) =>
                    getConversionIndicesCoefficientKey(ConversionCoefficientsKeys.kpir, row.constructionType.id),
                isEditable,
                control,
                doNotCheckRowFlag: true,
                width: isEditable ? 85 : 60,
                textFieldWidth: 'full',
                placeholder: '0',
            }),
        ],
        [control, isEditable],
    );
};
